import React from 'react';
const FacebookIcon = ({ size = 24, color = "currentColor", className = "" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`fill-current w-full h-full ${className}`}
        style={{ width: size, height: size }}
        viewBox="0 0 10 20"
        fill="currentColor"
    >
        <path d="M7 10H4v8H1V10H0V7h1V5c0-2.2 1.35-3.5 3.5-3.5h2c.7 0 1.25.1 1.5.1v3h-1.5c-1 0-1.5.5-1.5 1.5V7h3l-.5 3z" />
    </svg>
);

export default FacebookIcon;